import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-upgrade-modal',
  templateUrl: './upgrade-modal.component.html',
  styleUrls: ['./upgrade-modal.component.css']
})
export class UpgradeModalComponent implements OnInit {

  user: any = null;

  @ViewChild('upgradeModal', { static: false })
  modalWindow: ElementRef;

  @Output()
  plan = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  selectPlan(type: string) {
    this.plan.emit(type);
  }

  setUser(user: any) {
    this.user = user;
  }

  close() {
    $('#upgradeModal').modal('hide');
  }

}
